import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { AuthenticationService } from '../services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService, private toastr: ToastrService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // || err.status === 403
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                location.reload();
            }
            console.log(err);
            if (err.error.error) {
                this.toastr.error(err.error.error);
            }

            const error = err.error.message || err.statusText;
            this.toastr.error(`${error}!`, `Try Again!`)
            return throwError(error);
        }));
    }
}
